export class RegisterModel {
  USERNAME: string;
  EMAIL: string;
  PASSWORD: string;

  constructor() {
    this.USERNAME = "";
    this.EMAIL = "";
    this.PASSWORD = "";
  }
}
